module.exports = __webpack_public_path__ + "static/media/spinner-lightbg-l.23e0c1c9.gif";